import router from '@iez/core/router/'
import { computed, reactive } from '@vue/composition-api'
// import log from '@iez/lib/log'

const log = () => {}

export const prioritiesGlobal = []

/**
 * TO DO : manually set url to a not priorized route
 * handle this case (when priorities are resolved for e.g)
 * it redirects badly on /home
 */

let guard = 0
export default priorities => {
  prioritiesGlobal.push(
    ...priorities.map((priority, index) => reactive({
      ...priority,
      isResolved: false,
      previousPriorities: computed(
        () => prioritiesGlobal
          .filter(
            (_, _index) =>
              _index < index
          )
      )
    }))
  )
  log('priorities', priorities)
  router.beforeEach(async (to, from, next) => {
    if (++guard > 1000) {
      console.error('infini')
      return
    }
    log(`=`.repeat(10))
    log(
      'im from', from.name,
      'i want to go to', to.name
    )
    for (
      const {
        name,
        isResolvedSync,
        isResolvedAsync,
        isAllowed,
        ignoreIfResolved,
        shouldStartAt
      } of prioritiesGlobal
    ) {
      log(
        'Testing',
        name,
        `to`,
        to.name, {
          name,
          isResolvedSync,
          isResolvedAsync,
          isAllowed,
          ignoreIfResolved
        }
      )

      // allow && !resolved
      const isResolved = (
        (isResolvedSync && isResolvedSync()) ||
        (isResolvedAsync && (await isResolvedAsync()))
      )

      // globally update isResolved
      prioritiesGlobal
        .find(priority => priority.name === name)
        .isResolved = isResolved

      log('isResolved ?', isResolved)

      /**
       * Destination is priority (can be just after redirection)
       */
      if (to.name === name) {
        if (isResolved) {
          log('already resolved', name, 'maybe backing ?')
          if (ignoreIfResolved) {
            // useful for authentication for instance
            log('ignore on back')
            router.back()
            return
          } else {
            // just go
            next()
            return
          }
        } else {
          log('Go to', name, 'destination is the one to resolve, maybe redirected ?')
        }
        log(`End.`)
        next()
        return
      }

      /**
       * Allowed paged
       */
      if (
        (isAllowed && isAllowed(to) ||
        to.name === `InputImage`)
      ) {
        log(`Is allowed`, to.name, {
          name,
          ignoreIfResolved,
          isResolved
        })
        if (ignoreIfResolved && isResolved) {
          log('ignore on back')
          router.back()
          return
        }
        next()
        return
      } else {
        log(`Not allowed btw...`, to.name)
      }

      /**
       * Redirection to do
       */
      if (!isResolved) {
        log('Redirect to', name, `bc not already resolved`)
        log(`Note : `, from.name, to.name)
        /**
         * Si là où je veux aller de façon délibérée
         * est quelque chose de non résolu
         * alors replace: false
         * tout simplement !
         */
        if (shouldStartAt && shouldStartAt !== from.name) {
          log(`Should start at`, shouldStartAt)
          next({
            name: shouldStartAt,
            replace: true
          })
          return
        }
        next({
          name,
          replace: true
        })
        return
      } else {
        /**
         * Nothing to do
         */
        log('This priority is already resolved, nothing to do')
      }
    }
    log('All is resolved. Just next to', to.name)
    next()
  })
}
